import React, { memo, useMemo } from 'react';
import { StyleSheet, Text, useWindowDimensions, View, } from 'react-native';
import ThemeProvider from '@voltmoney/theme';
import { ColorTokens, FontFamilyTokens, FontSizeTokens, PartnerAccountType, } from '@voltmoney/schema';
/**
 * Primary UI component for user interaction
 */
const PartnerSignUpReferrer = ({ isRefCode, partnerName, partnerAccountType }) => {
    const BreakPoint = {
        Web: 1024,
    };
    const { width } = useWindowDimensions();
    const _isMobile = width < BreakPoint.Web ? true : false;
    const theme = ThemeProvider.getTheme();
    const fontFamilyMap = theme.fontFamily;
    const fontSizeMap = theme.fontSize;
    const colorMap = theme.colors;
    const styles = StyleSheet.create({
        baseText: {
            fontFamily: fontFamilyMap[FontFamilyTokens.Poppins],
            fontSize: _isMobile
                ? fontSizeMap[FontSizeTokens.XL]
                : fontSizeMap[FontSizeTokens.XXL],
            fontWeight: '700',
            lineHeight: 32,
            color: colorMap[ColorTokens.Grey_Night],
        },
        innerText: {
            color: colorMap[ColorTokens.Grey_Charcoal],
        },
        slashText: {
            textDecorationLine: 'line-through',
            textDecorationStyle: 'solid',
            textDecorationColor: 'red',
        },
        partner_title: {
            fontFamily: fontFamilyMap[FontFamilyTokens.Poppins],
            fontSize: fontSizeMap[FontSizeTokens.XXL],
            fontWeight: '600',
            lineHeight: 32,
            color: colorMap[ColorTokens.Grey_Charcoal],
        },
        baseText_partnerName: {
            fontFamily: fontFamilyMap[FontFamilyTokens.Inter],
            fontSize: _isMobile
                ? fontSizeMap[FontSizeTokens.SM]
                : fontSizeMap[FontSizeTokens.MD],
            fontWeight: '400',
            lineHeight: 24,
            color: colorMap[ColorTokens.Grey_Charcoal],
        },
        innerText_partnerName: {
            color: colorMap[ColorTokens.Grey_Charcoal],
        },
        slashText_partnerName: {
            textDecorationLine: 'line-through',
            textDecorationStyle: 'solid',
            textDecorationColor: 'red',
        },
    });
    const _partnerAccountTypeEqualsAffliate = useMemo(() => (React.createElement(View, null, partnerName ? (React.createElement(View, null,
        React.createElement(View, null,
            React.createElement(Text, { style: styles.partner_title },
                React.createElement(Text, { style: {
                        color: colorMap[ColorTokens.Grey_Night],
                    } }, "Volt money"),
                ' ',
                React.createElement(Text, null, "has invited you to become a partner"))),
        React.createElement(View, null,
            React.createElement(Text, { style: {
                    fontFamily: 'Poppins',
                    fontWeight: '700',
                    fontSize: 24,
                    lineHeight: 32,
                    color: '#1D2939'
                } },
                React.createElement(Text, null,
                    "Discover",
                    ' '),
                React.createElement(Text, { style: {
                        color: '#109648'
                    } },
                    "unlimited earning potential",
                    ' '),
                React.createElement(Text, null,
                    "as a Volt Money ",
                    ' '),
                React.createElement(Text, { style: {
                        color: '#1434CB'
                    } },
                    "affiliate partner",
                    ' '))))) : (React.createElement(View, null,
        React.createElement(Text, { style: {
                fontFamily: 'Poppins',
                fontWeight: '700',
                fontSize: _isMobile ? 20 : 24,
                lineHeight: 32,
                color: '#1D2939'
            } },
            React.createElement(Text, null,
                "Discover",
                ' '),
            React.createElement(Text, { style: {
                    color: '#109648'
                } },
                "unlimited earning potential",
                ' '),
            React.createElement(Text, null,
                "as a Volt Money ",
                ' '),
            React.createElement(Text, { style: {
                    color: '#1434CB'
                } },
                "affiliate partner",
                ' ')))))), [partnerName, isRefCode, _isMobile]);
    const _childDefault = useMemo(() => (React.createElement(View, null, partnerName ? (React.createElement(View, null,
        React.createElement(View, null,
            React.createElement(Text, { style: styles.partner_title },
                React.createElement(Text, { style: {
                        color: colorMap[ColorTokens.Grey_Night],
                    } }, "Volt money"),
                ' ',
                React.createElement(Text, null, "has invited you to become a partner"))),
        React.createElement(View, null,
            React.createElement(Text, { style: styles.baseText_partnerName },
                "Help your clients meet short term cash needs",
                ' ',
                React.createElement(Text, { style: styles.innerText_partnerName },
                    "by",
                    ' ',
                    React.createElement(Text, { style: styles.slashText_partnerName }, "redeeming"),
                    ' ',
                    "pledging mutual funds"))))) : (React.createElement(View, null,
        React.createElement(Text, { style: styles.baseText },
            "Help your clients meet short term cash needs",
            ' ',
            React.createElement(Text, { style: styles.innerText },
                "by",
                ' ',
                React.createElement(Text, { style: styles.slashText }, "redeeming"),
                ' ',
                "pledging mutual funds")))))), [partnerName, isRefCode, _isMobile]);
    return partnerAccountType === PartnerAccountType.AFFILIATE ?
        React.createElement(React.Fragment, null, _partnerAccountTypeEqualsAffliate) :
        React.createElement(React.Fragment, null, _childDefault);
};
export default memo(PartnerSignUpReferrer);
export { PartnerSignUpReferrer };
